; "use_strict";
(function defSideBar(global) {

  var cssClass = "tab_item";

  /**
  * Часто используемые селекторы
  */
  var noCardFormAtStartFound = false;

  var tabSelector = "div.tab_item";
  var byNameSelectorTemplate = "{0}[name='{1}']";
  var cardFormTabTemplate = '#CardForm_Tab_{0}';
  var cardFormTabSelector = 'div.CardForm_Tab';

  /**
  * У проводника немного другая верстка
  */
  /*if (global.getLocation() == "explorer") {
    sideBarConatainerSelector = "#sidebar_container";
    tabSelector = "div.sidebar_item";
    cssClass = "sidebar_item";
  }*/
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Частоиспользуемые jQuery объекты
  */

  /**
  * Класс-обертка для панели закладок
  * @class WebAccess.components.wrappers.sideBar.SideBar
  * @since 5.2.0.1600  
  */
  var _ExplorerSideBar = WA.CMP.wrappers.sideBar.SideBar.extend({
    _jContainer: null,
    _current: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика сворачивания / разорачивания горизонтальных закладок в кнопку еще.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_fitHorizontalTabs
    * @private
    * @since 5.2.0.1600
    * @return {WebAccess.current.sideBar}
    */
    _fitHorizontalTabs: global.TCD(function () {
      return false;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика сворачивания / разорачивания вертикальных закладок в кнопку Еще.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_fitVerticalTabs
    * @private
    * @since 5.2.0.1600
    * @return {WebAccess.current.sideBar}
    */
    _fitVerticalTabs: global.TCD(function () {
      return false;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подсчет ширины или высоты всех закладок.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_getSideBarSize
    * @since 5.2.0.1600
    * @private
    * @param {object} jSideBar - контейнер сайдбара
    * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
    * @return {integer} ширина сайдбара
    */
    _getSideBarSize: function (sizeName) {
      var me = this;
      var sideBarSize = 0;

      me._jSideBar.find('span:first').find(tabSelector).each(function () {
        sideBarSize += $.fn[sizeName].call($(this), true);
      });

      if (!this.isVertical()) sideBarSize += $(".more").width();
      return sideBarSize;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение ширины или высоты последней нескрытой закладки (не учитывая закладку "Еще").
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_getLastTabSize
    * @since 5.2.0.1600
    * @private
    * @param {object} jSideBar - контейнер сайдбара
    * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
    * @return {integer}
    */
    _getLastTabSize: function (sizeName) {
      var me = this;
      var tabs = me._jSideBar.find('span:first').find(tabSelector);
      return $.fn[sizeName].call(tabs.not('.more').last(), true);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /** 
    * Развернуть содержимое закладок или дерево задач в проводнике.
    * В карточках объектов пошагово переносит скрытые закладки с закладки «Еще» на боковую панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#expand
    */
    expand: global.TCD(function () {
      var jTreeArea = $(".explorer-header__tree-area");
      var jLeftContainer = $("#left_column");
      var jTreeContainer = $("#tree_container");
      var jExpandTreeContainer = $("#expand_tree_container");
      var jExpandHeaderContainer = $(".explorer-header__expand-area");
      var jRightColumn = $("#right_column");
      const jHeader = $('#top_content');

      jLeftContainer.removeClass('left_column_collapsed');
      jRightColumn.removeClass('left_column_collapsed');
      jHeader.removeClass('left_column_collapsed');

      jExpandTreeContainer.hide();
      jExpandHeaderContainer.hide();

      jTreeContainer.show();
      jTreeArea.show();

      $.cookie('SideBarCollapsed', '0', { expires: 70000 });
      return this;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Свернуть содержимое закладок или дерево папок в проводнике.
    * В карточках объектов пошагово переносит закладки с боковой панели на закладку «Еще».
    * @method WebAccess.components.wrappers.sideBar.SideBar#collapse
    * @param {string} tabName Имя закладки
    * @return {WebAccess.current.sideBar | boolean} True – имеется возможность свернуть содержимое закладок, иначе False.
    */
    collapse: global.TCD(function () {
      var jTreeArea = $(".explorer-header__tree-area");
      var jLeftContainer = $("#left_column");
      var jTreeContainer = $("#tree_container");
      var jExpandTreeContainer = $("#expand_tree_container");
      var jExpandHeaderContainer = $(".explorer-header__expand-area");
      var jRightColumn = $("#right_column");
      const jHeader = $('#top_content');

      jLeftContainer.addClass('left_column_collapsed');
      jRightColumn.addClass('left_column_collapsed');
      jHeader.addClass('left_column_collapsed');

      jTreeContainer.hide();
      jTreeArea.hide();

      jExpandTreeContainer.show();
      jExpandHeaderContainer.show();

      $.cookie('SideBarCollapsed', '1', { expires: 70000 });
      return this;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить, свернута ли боковая панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#isCollapsed
    * @param {String} tabName Имя закладки
    * @since 5.2.0.1600
    */
    isCollapsed: function () {
      var me = this;
      return !$("#tree_container").is(":visible");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//     

    /**
    * Изменить расположение боковой панели.
    *

    * @method WebAccess.components.wrappers.sideBar.SideBar#setOrientation
    * @todo проверить в разных местах, например в проводнике, мастерах
    * @fixme с иконками в обратную сторону пока плохо.
    * @param {ORIENTATION} orientation Режим расположения боковой панели. 
    * Возможные значения:HORIZONTAL – горизонтальное; VERTICAL – вертикальное.
    * @since 5.2.0.1600
    * @example
    *
    * //Установить горизонтальное расположение боковой панели.
    * WA.CR.sideBar.setOrientation(ORIENTATION.HORIZONTAL)
    */
    setOrientation: function (orientation) {
      var me = this;

      if (orientation == ORIENTATION.HORIZONTAL) {
        me._jSideBar.removeClass("vertical").addClass("horizontal");
        $("#right_column").addClass("no_margin");
        me._jSideBar.find(tabSelector + " p").each(function () {
          var smallIcon = $(this).data('smallicon');
          $(this).removeClass().addClass(smallIcon);
        });

        this._fitHorizontalTabs();
        this._moveSidebarBeforeCustomWorkCard();
      } else {
        me._jSideBar.addClass("vertical").removeClass("horizontal");

        $("#right_column").removeClass("no_margin");
        me._jSideBar.find(tabSelector + " p").each(function () {
          var icon = $(this).data('icon');
          $(this).removeClass().addClass(icon);
        });

        this._fitVerticalTabs();
        this.moveSidebarToLeftColumn();
      };

      // Скрывает панель "Еще".
      $('body').off('click.tabs').on('click.tabs', function () {
        me._jAfterTabs.addClass("hidden");
      });

      // Сворачивает вкладки в "Еще" при изменении размеров экрана.
      $(window).bind('resizeEnd', function () {
        me._jAfterTabs.addClass("hidden");
        if (me._jSideBar.hasClass("horizontal")) {
          me._fitHorizontalTabs();
        } else {
          me._fitVerticalTabs();
        };
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить, вертикально ли распологается боковая панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#isVertical
    * @since 5.0.0.4206
    * @return {boolean} True – боковая панель располагается вертикально, иначе False.
    */
    isVertical: function () {
      var me = this;
      return !$("#left_column").hasClass("horizontal");
    },

    /**
    * Переносит вкладки внутрь основной области, что бы минитулбар вложений был с ними на одном уровне.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#_moveSidebarBeforeCustomWorkCard
    * @since 5.2.0.1600    
    * @private 
    */
    _moveSidebarBeforeCustomWorkCard: function () {
      var me = this;
      var view = GetParamInURL("view").toLowerCase();
      if (view !== "card" && view !== "") return;
      if (me._jSideBar.hasClass('horizontal')) {
        var jMainContainer = $('#main_container');
        var jAttachment = jMainContainer.find('.attachments_td');
        var jLeftColumn = $('#left_column');
        if (jAttachment.length > 0) {
          // Перенос.
          jMainContainer.find('.card').before(jLeftColumn);
          // Корректируем стили левой колонки, что бы не наезжала на минитулбар вложений.
          var attachmentWidth = parseInt(jAttachment.width(), 10);
          jLeftColumn.css({ 'width': 'auto', 'marginRight': attachmentWidth - 5 });
          // Корректируем размер полей текста ЗЗУ.
          if (typeof (initSavedTextHeight) !== 'undefined') initSavedTextHeight();
        }
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить первоначальное положение закладок боковой панели.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#moveSidebarToLeftColumn
    * @since 5.2.0.1600    
    */
    // 
    moveSidebarToLeftColumn: function () {
      var me = this;
      var jLeftColumn = $('#left_column');
      var jRightColumn = $('#right_column');
      // Перенос.
      jRightColumn.before(jLeftColumn);
      // Корректируем стили левой колонки.
      jLeftColumn.css({ 'width': '', 'marginRight': '' }); //FIXME: проверить на планшетах
      // Корректируем размер полей текста ЗЗУ.
      if (typeof (initSavedTextHeight) !== 'undefined') initSavedTextHeight();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  WA.CMP.wrappers.sideBar._ExplorerSideBar = _ExplorerSideBar;

})(window.WA);